import type { IconProps } from "../types/icon";

export const SunIcon = ({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <g fill={color}>
        <path d="M9 0H7v2h2zM14.294 3.052 12.88 1.637 11.465 3.05l1.414 1.414zM16 7h-2v2h2zM11.535 13.02l1.415 1.413 1.414-1.415-1.415-1.413zM9 14H7v2h2zM1.566 12.949l1.414 1.414 1.415-1.413-1.414-1.415zM2 7H0v2h2zM4.465 3.12 3.05 1.707 1.636 3.12l1.415 1.414zM8 4C5.8 4 4 5.8 4 8s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4" />
      </g>
    </svg>
  );
};
